import React, { useState } from "react";
import "./modal.scss";
// Component Library
import Button, { BUTTON_DISPLAY } from "@acadia-ui/button";
import Loading from "@acadia-ui/loading";
import Modal from "@acadia-ui/modal";
import { ToastNotification, TOAST_TYPE, showToast } from "@acadia-ui/toast";
// Actions
import { pushPackagesToGCM } from "../../Flux/Actions/PackagesActions";
import { pushPlacementsToGCM } from "../../Flux/Actions/PlacementActions";

const GCMPushModal = ({ modalId, type, data, refresh }) => {
	const [isLoading, setIsLoading] = useState(false);

	function closeModal() {
		setIsLoading(false);
		Modal.hide(modalId);
	}

	function handleSync() {
		setIsLoading(true);
		let pushEndpoint;
		if (type === "Package") {
			pushEndpoint = pushPackagesToGCM(
				data.map((row) => {
					return row.PackageID;
				})
			);
		} else if (type === "Placement") {
			pushEndpoint = pushPlacementsToGCM(
				data.map((row) => {
					return row.PlacementID;
				})
			);
		}
		pushEndpoint
			.then(() => {
				showToast(
					"workbookToasts",
					<ToastNotification
						type={TOAST_TYPE.SUCCESS}
						message={`Selected ${type?.toLowerCase()}${data.length > 1 ? "s have" : " has"} been synced successfully to Google Campaign Manager`}
						timed={5000}
					/>
				);
			})
			.catch(async (error) => {
				const errorObject = await error.details.json();
				if (errorObject?.detail) {
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message={errorObject?.detail} />);
				} else {
					try {
						errorObject?.forEach((row) => {
							if (row.ExternalSystemStatusID == 2) {
								setTimeout(() => {
									showToast(
										"workbookToasts",
										<ToastNotification type={TOAST_TYPE.ERROR} message={`${type} ${row[`${type}ID`]} failed: ${row.ExternalSystemResponse}`} />
									);
								}, 100);
							}
						});
					} catch {
						showToast(
							"workbookToasts",
							<ToastNotification type={TOAST_TYPE.ERROR} message={`There was an issue syncing ${type?.toLowerCase()}${data.length > 1 ? "s" : ""}`} />
						);
					}
				}
			})
			.finally(() => {
				closeModal();
				refresh(true);
			});
	}

	return (
		<Modal
			id={modalId}
			className="GCM_sync_modal"
			heading="Sync Confirmation"
			description={`Click "Sync" to synchronize the selected ${type?.toLowerCase()}${data.length > 1 ? "s" : ""} with Google Campaign Manager.`}
			onRequestClose={closeModal}
			userClosable={!isLoading}
			actionSetProps={{
				actionsRight: (
					<>
						<Button disabled={isLoading} display={BUTTON_DISPLAY.SECONDARY} onClick={closeModal} data-tracking-id-alt="cancel-gcm-sync">
							Cancel
						</Button>
						<Button disabled={isLoading} onClick={handleSync} data-tracking-id-alt="confirm-gcm-sync">
							Sync
						</Button>
					</>
				)
			}}
			onClick={() => {}}
		>
			{isLoading && <Loading className="modalLoading" />}
		</Modal>
	);
};
export default GCMPushModal;
